<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                    <el-form label-position="top">
                        <el-form-item label="筛选序列号">
                            <el-select v-model="filter.serialId" placeholder="序列号" clearable
                                       filterable remote
                                       :remote-method="handelSearchBySerialId"
                                       @change="handleIndexShop()">
                                <el-option
                                        v-for="item in serials"
                                        :key="item.id"
                                        :label="item.serial_id"
                                        :value="item.serial_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="筛选状态">
                            <el-select v-model="filter.status" placeholder="状态" clearable
                                       filterable
                                       @change="handleIndexShop()">
                                <el-option
                                        v-for="item in arr_status"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="筛选类型">
                            <el-select v-model="filter.type" placeholder="类型" clearable
                                       filterable
                                       @change="handleIndexShop()">
                                <el-option
                                        v-for="item in arr_type"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
            </div>
        </div>
        <div class="m-portlet right m-b-0">

            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59+'px'}" v-loading="loading">
                <div>
                    <el-button size="mini" @click="handleStoreShopMsg()">新增商品序列号</el-button>
                </div>
                <el-table v-if="!loading"
                          :data="orderShopMsgs"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-40"
                          size="middle">
                    <el-table-column prop="sign" label="内部编号" min-width="10%"> </el-table-column>
                    <el-table-column prop="description" label="描述" min-width="10%"> </el-table-column>
                    <el-table-column prop="supplier" label="来源" min-width="10%"> </el-table-column>
                    <el-table-column prop="receiver" label="所属" min-width="10%"> </el-table-column>
                    <el-table-column prop="serial_id" label="序列号" min-width="10%"> </el-table-column>
                    <el-table-column prop="statusName" label="状态" min-width="10%"> </el-table-column>
                    <el-table-column prop="typeName" label="类型" min-width="10%"> </el-table-column>
                    <el-table-column label="操作" min-width="10%">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleUpdateShopMsg(scope.row)">修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import store from '@/store'
    export default {
        name: "students-list",
        data() {
            return {
                path: '/student/list',
                loading: true,
                shopMsgs: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                filter:{
                    storeId: '',
                    serialId:'',
                    status:'',
                    type:''
                },
                serials:[],
                arr_status:[
                    {
                        id:1,
                        name:'已分配'
                    },
                    {
                        id:'2',
                        name:'未分配'
                    }
                ],
                arr_type:[
                    {
                        id:1,
                        name:'出售'
                    },
                    {
                        id:'2',
                        name:'出租'
                    },
                    {
                        id:'3',
                        name:'老师'
                    }
                ],
            }
        },
        props: {},
        components: {},
        created() {
            this.handleIndexShop();
            this.handelSearchBySerialId()
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderShopMsgs: function () {
                return this._.orderBy(this.shopMsgs, 'id', 'asc');
            }
        },
        methods: {
            handleIndexShop(currentPage=1) {
                this.loading=true;
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$axios.get(store.state.server + '/getShopNameById?'+
                    'nameId='+this.$route.params.id +
                    '&serialId='+this.filter.serialId +
                    '&status='+this.filter.status +
                    '&type='+this.filter.type +
                    '&page='+this.currentPage +
                    '&limit=' + this.currentPageSize
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.loading=false;
                        if (Object.keys(response.data.content.list).length !== 0) {
                            this.shopMsgs=response.data.content.list
                        } else {
                            this.shopMsgs = new Object();
                        }
                        this.total=response.data.content.total
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexShop(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexShop(this.currentPage)
            },
            handleStoreShopMsg(){
                this.$Win.openModal('Dialogs_StoreShopMsg', 400, 400, '创建商品编号',{'nameId':this.$route.params.id,'shopMsg':''});
            },
            handleUpdateShopMsg(val){
                this.$Win.openModal('Dialogs_StoreShopMsg', 400, 400, '修改商品编号',{'nameId':this.$route.params.id,'shopMsg':val});
            },
            handelSearchBySerialId(val=''){
                this.$axios.get(store.state.server + '/searchBySerialId?serialId=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.serials=response.data.content.shops
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
</style>
